/* eslint-disable no-dupe-keys */
export default {
  model_version_log_audit: {
    name: '数据版本日志',
    // 属性（一般与对象内容匹配）
    prop: {
      auditable_id: '被修改的对象',
      auditable_type: '操作对象类型',
      associated_id: '归属对象',
      associated_type: '关联对象类型',
      user: '操作员',
      action: '动作',
      audited_changes: '变化内容',
      version: '版本',
      comment: '备注',
      remote_address: 'IP',
      request_uuid: 'WEB请求ID',
      created_at: '创建时间'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      auditable_id: '被修改的对象',
      auditable_type: '操作对象类型',
      associated_id: '归属对象',
      associated_type: '关联对象类型',
      user_id: '操作员',
      action: '动作',
      audited_changes: '变化内容',
      version: '版本',
      comment: '备注',
      remote_address: 'IP',
      request_uuid: 'WEB请求ID',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    actions: {
      destroy: '删除',
      update: '更新',
      create: '新增'
    },
    action_icons: {
      destroy: 'el-icon-delete',
      update: 'el-icon-edit',
      create: 'el-icon-plus'
    },
    action_tag_types: {
      destroy: 'danger',
      update: 'success',
      create: 'primary'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询被修改/归属对象ID'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      versions: '历史版本'
    },
    titles: {
      base_info: '基本信息'
    },
    auditable_types: {
      ServiceProvider: '运营商',
      SettlementRule: '结算规则',
      ChargeStation: '监控站',
      EvChargingStation: '共享站',
      EvChargingPile: '充电桩',
      EvChargingGun: '充电枪',
      RoadBook: '路书',
      Image: '图片',
      Picture: '图片',
      BillingRule: '费率',
      Charger: '充电桩',
      DataCollector: '采集器',
      ChargerSpecialBillingRule: '周期费率',
      StationComment: '站点评',
      StationCommentReply: '点评回复',
      User: '用户',
      Car: '车辆',
      Magcard: '磁卡',
      Feedback: '意见反馈',
      VirtualUser: '运营商虚拟用户',
      Group: '集团优惠',
      GroupDiscount: '集团折扣',
      GroupDiscountChargeStation: '折扣充电站',
      GroupApplication: '集团用户申请',
      CouponDefinition: '优惠券定义',
      ChargingPackageDefinition: '充电包定义',
      MemberShip: 'VIP会员定义',
      GiftCardDefinition: '礼品卡定义',
      GiftCardCouponDefinition: '礼品卡优惠券',
      OperationActivity: '邀请活动',
      Trigger: '活动',
      EcaRule: '规则',
      Product: '商品',
      Carousel: '走马灯',
      Activity: '弹窗广告',
      AppPage: '应用页面',
      AppMenu: '应用菜单',
      EvcsOperator: '第三方平台',
      EvcsOperatorEcmpStation: '互通站',
      EvcsCommunicateConfig: '互通配置',
      Admin: '管理员',
      Enumeration: '桩配置',
      SystemSetting: '系统配置',
      Tag: '标签',
      ParkingLock: '地锁',
      ExportFile: '导出',
      Order: '订单',
      ProductOrder: '商品订单',
      LogisticsRecord: '物流记录',
      RoleAuthorization: '角色权限',
      EvChargingStationSettlement: '站结算',
      ChargeStationsBillingRuleTimer: '费率定时器',
      BillingRuleTimer: '费率定时器',
      NvrChannel: '摄像头',
      IdleFee: '占位费规则',
      IdleFeeBill: '占位费账单'
    }
  }
}
